"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilestoneTimeline = void 0;
var moment = require("moment");
var milestone_progress_1 = require("../milestone-progress");
var timeline_node_1 = require("./timeline-node");
var MilestoneTimeline = /** @class */ (function () {
    function MilestoneTimeline(props, verbose) {
        if (verbose === void 0) { verbose = false; }
        this.props = props;
        this.verbose = verbose;
        this.nodes = [];
        this.nodesFull = [];
        Object.assign(this, props);
        if (props.nodes && props.nodes.length > 0) {
            this.nodesFull = props.nodes.map(function (node) { return new timeline_node_1.TimelineNode(node); });
        }
    }
    MilestoneTimeline.prototype.reset = function (inputs, dog) {
        var _this = this;
        if (this.verbose) {
            console.log('Resetting timeline...');
        }
        this.nodesFull = this.generateNodes(inputs, dog)
            .map(function (node) { return new timeline_node_1.TimelineNode(node); });
        if (this.verbose) {
            console.log('New Nodes (Sorted Order)', this.nodesFull);
        }
        inputs.forEach(function (input) {
            // @TODO insert into other nodes not just start node - handle carried logic
            var _a = _this.findIndexStartEnd(input.instance, dog), start = _a.start, end = _a.end;
            // @TODO If start already happened and milestone hasn't expired append to the next valid month
            _this.nodesFull[start].add(input, dog);
        });
        this.nodes = this.nodesFull.map(function (node) { return node.toJSON(); });
    };
    MilestoneTimeline.prototype.update = function (input, dog) {
        var _this = this;
        // @TODO insert into other nodes not just start node - handle carried logic
        var _a = this.findIndexStartEnd(input.instance, dog), start = _a.start, end = _a.end;
        // @TODO If start already happened and milestone hasn't expired append to the next valid month
        if (input.progress.id) {
            var indexes = __spreadArrays([start], this.findAssociatedNodes(input.progress.id));
            // If exists
            if (indexes.length > 0) {
                // Remove from existing nodes if not part of start
                indexes.forEach(function (index) {
                    if (index === start) {
                        _this.nodesFull[index].update(input, dog);
                    }
                    if (index !== start) {
                        _this.nodesFull[index].remove(input.progress.id);
                    }
                });
            }
            else {
                this.nodesFull[start].add(input, dog);
                this.nodes[start] = this.nodesFull[start].toJSON();
            }
        }
        else {
            throw new Error('Progress must have an ID');
        }
        return start;
    };
    MilestoneTimeline.prototype.removeElement = function (id) {
        var _this = this;
        var indexes = this.findAssociatedNodes(id);
        indexes.forEach(function (index) {
            _this.nodesFull[index].remove(id);
        });
        this.nodes = this.nodesFull.map(function (node) { return node.toJSON(); });
    };
    Object.defineProperty(MilestoneTimeline.prototype, "elements", {
        get: function () {
            var elements = [];
            this.nodesFull.forEach(function (node) {
                node.elementsFull.forEach(function (element) {
                    elements.push(element);
                });
            });
            return elements;
        },
        enumerable: false,
        configurable: true
    });
    MilestoneTimeline.prototype.toJSON = function () {
        return {
            nodes: this.nodesFull.map(function (node) { return node.toJSON(); })
        };
    };
    MilestoneTimeline.prototype.generateNodes = function (inputs, dog) {
        // Reset nodes
        this.nodes = [];
        // Determine the min and max dates
        var _a = this.minMaxMilestones(inputs, dog), start = _a.start, end = _a.end;
        if (this.verbose) {
            console.log('MinMax:', start.format('YYYY-MM-DD'), '-', end.format('YYYY-MM-DD'));
        }
        // count up by month until we reach end
        var offset = 0;
        var range = end.endOf('month').diff(start.startOf('months'), 'months');
        if (range < 0) {
            throw new Error('Cannot have a negative range');
        }
        var present = start.startOf('month');
        var tick;
        while (offset <= range) {
            tick = moment(present)
                .add(offset++, 'month');
            this.nodes.push({
                elements: [],
                updated: new Date().toISOString(),
                year: tick.year(),
                month: timeline_node_1.TimelineNode.month(tick.month())
            });
        }
        // Assuming nodes are sorted by time
        return this.nodes;
    };
    MilestoneTimeline.prototype.minMaxMilestones = function (inputs, dog) {
        var data = {
            start: moment().set('year', new Date().getFullYear() + 100),
            end: moment().set('year', new Date().getFullYear() - 100)
        };
        var startM;
        var endM;
        inputs.forEach(function (input) {
            var _a = milestone_progress_1.MilestoneProgress.absoluteTimeframe(input.instance, dog), start = _a.start, end = _a.end;
            startM = moment(start.date.min);
            endM = moment(end.date.max);
            if (data.start.isAfter(startM)) {
                data.start = startM;
            }
            if (data.end.isBefore(endM)) {
                data.end = endM;
            }
        });
        return data;
    };
    MilestoneTimeline.prototype.findAssociatedNodes = function (id) {
        var indexes = [];
        for (var i = 0; i < this.nodesFull.length; i++) {
            for (var j = 0; j < this.nodesFull[i].elementsFull.length; j++) {
                if (this.nodesFull[i].elementsFull[j].progress.id === id) {
                    indexes.push(i);
                }
            }
        }
        return indexes;
    };
    MilestoneTimeline.prototype.findTodaysIndex = function () {
        var today = moment();
        return this.findIndex(today.month(), today.year());
    };
    MilestoneTimeline.prototype.findIndex = function (month, year) {
        for (var i = 0; i < this.nodesFull.length; i++) {
            if (timeline_node_1.TimelineNode.monthIndex(this.nodesFull[i].month) === month && this.nodesFull[i].year === year) {
                return i;
            }
        }
        return -1;
    };
    MilestoneTimeline.prototype.findIndexStartEnd = function (milestone, dog) {
        var _a = milestone_progress_1.MilestoneProgress.absoluteTimeframe(milestone, dog), start = _a.start, end = _a.end;
        var startM = moment(start.date.min);
        var endM = moment(end.date.max);
        var data = { start: -1, end: -1 };
        var nodeStart;
        var nodeEnd;
        var output = [];
        var infos = [];
        this.nodesFull.forEach(function (node) {
            infos.push(node.info);
        });
        output.push("Nodes: " + infos.join(', '));
        for (var i = 0; i < this.nodesFull.length; i++) {
            var inner = [];
            nodeStart = this.nodesFull[i].start;
            nodeEnd = this.nodesFull[i].end;
            inner.push("Start checking if " + startM.format('YYYY-MM-DD') + " between " + nodeStart.format('YYYY-MM-DD') + " and " + nodeEnd.format('YYYY-MM-DD') + " (" + this.nodesFull[i].info + " Node)");
            if (startM.isBetween(nodeStart, nodeEnd, 'day', '[]')) {
                if (data.start === -1) {
                    inner.push('Start is between!');
                    data.start = i;
                }
                else {
                    inner.push("Start should not hit this twice! " + startM.format('YYYY-MM-DD') + " between " + nodeStart.format('YYYY-MM-DD') + " and " + nodeEnd.format('YYYY-MM-DD') + " (" + this.nodesFull[i].info + " Node)");
                }
            }
            inner.push("End checking if " + endM.format('YYYY-MM-DD') + " between " + nodeStart.format('YYYY-MM-DD') + " and " + nodeEnd.format('YYYY-MM-DD') + " (" + this.nodesFull[i].info + " Node)");
            if (endM.isBetween(nodeStart, nodeEnd, 'day', '[]')) {
                if (data.end === -1) {
                    inner.push('End is between!');
                    data.end = i;
                }
                else {
                    inner.push("End should not hit this twice! " + endM.format('YYYY-MM-DD') + " between " + nodeStart.format('YYYY-MM-DD') + " and " + nodeEnd.format('YYYY-MM-DD') + " (" + this.nodesFull[i].info + " Node)");
                }
            }
            output.push(inner.join('\n'));
            if (data.start > -1 && data.end > -1) {
                break;
            }
        }
        if (this.verbose) {
            console.log(output.join('\n'));
        }
        if (data.start > -1 && data.end > -1) {
            return data;
        }
        else {
            console.error(startM.format('YYYY-MM-DD'), data.start, endM.format('YYYY-MM-DD'), data.end);
            throw new Error('Could not find a valid end and start date or no node can slot this milestone');
        }
    };
    return MilestoneTimeline;
}());
exports.MilestoneTimeline = MilestoneTimeline;
